// assets
import { Story, Graph, Activity, RepeatCircle, Radar, Chart21 } from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  widgets: Story,
  sectorAnalysis: Graph,
  patternMatching: RepeatCircle,
  noTradeIndicator: Activity,
  smcWatch: Radar,
  orderFlow: Chart21
  // marketCharacter: Chart // unused while Market Character is hidden
};

// ==============================|| MENU ITEMS - ANALYZER ||============================== //

const analyzer: NavItemType = {
  id: 'group-analyzer',
  title: 'Analyzer',
  icon: icons.widgets,
  type: 'group',
  children: [
    {
      id: 'sector-performance',
      title: 'Sector Analysis',
      type: 'item',
      url: '/sector-performance',
      breadcrumbs: true,
      icon: icons.sectorAnalysis
    },
    {
      id: 'pattern-matching',
      title: 'Pattern Matching',
      type: 'collapse',
      icon: icons.patternMatching,
      children: [
        {
          id: 'daily-pattern-match',
          title: 'Daily Pattern Match',
          type: 'item',
          url: '/daily-pattern-match',
          icon: icons.patternMatching
        },
        {
          id: 'pattern-v1',
          title: 'Pattern Match v1',
          type: 'item',
          url: '/pattern-v1',
          icon: icons.patternMatching
        },
        {
          id: 'pattern-v2',
          title: 'Draw & Pattern Match',
          type: 'item',
          url: '/pattern-v2',
          icon: icons.patternMatching
        }
      ]
    },
    {
      id: 'smc-watch',
      title: 'SMC Watchlist',
      type: 'item',
      url: '/smc-watch',
      breadcrumbs: true,
      icon: icons.smcWatch
    },
    {
      id: 'no-trade-indicator',
      title: 'No-Trade Indicator',
      type: 'item',
      url: '/no-trade-indicator',
      breadcrumbs: true,
      icon: icons.noTradeIndicator
    },
    {
      id: 'order-flow',
      title: 'Order Flow',
      type: 'item',
      url: '/order-flow',
      breadcrumbs: true,
      icon: icons.orderFlow
    }
    // Market Character (FT-879) is hidden from the nav while the feature is on hold.
    // The route in MainRoutes.tsx is left intact, so the page is still reachable by URL.
    // {
    //   id: 'market-character',
    //   title: 'Market Character',
    //   type: 'item',
    //   url: '/market-character',
    //   icon: icons.marketCharacter
    // }
  ]
};

export default analyzer;
